/**
 * Fetches a tradein.
 *
 * @param {*} tradeinUuid
 * @returns the requested tradein
 */
async function getTradein(tradeinUuid) {
  const query = `
    query tradein(
      $tradeinUuid: String!
    ) {
      tradein(tradeinUuid: $tradeinUuid) {
        uuid
        state
        tradeinValueLow
        tradeinValueHigh
        tradeinItems {
          uuid
          catalogItemTitle
          itemImageUrl
          parentSku
          state
          tradeinValueLow
          tradeinValueLowDisplay
          tradeinValueHigh
          tradeinValueHighDisplay
        }
      }
    }
  `;
  const param = 'query-tradein';
  const response = await fetchWithAppName(`${global.url}${param}`, {
    body: JSON.stringify({ query, variables: { tradeinUuid } }),
  });

  const jsonData = await response.json();
  return jsonData.data.tradein;
}

const form = document.getElementById('shipping-form');
const submitBtn = document.getElementById('confirmation-submit-btn');
const inputs = form.querySelectorAll('.trade-in-shipping__input');
const errorMessages = form.querySelectorAll('.trade-in-shipping__error p-small');
const formBtn = document.getElementById('submit-btn');
const poBoxErrorMessage = form.querySelector('.poBoxMessage');
const poBoxErrorMessage2 = form.querySelector('.poBoxMessage2');
const militaryErrorMessage = form.querySelector('.militaryErrorMessage');

submitBtn.addEventListener('click', () => formBtn.click());

inputs.forEach(input => {
  input.addEventListener('blur', function () {
    toggleErrorMessage(input, true);
  });
})

form.addEventListener('input', function (e) {
  toggleErrorMessage(e.target);
  toggleSubmitButton();
});

form.addEventListener('submit', async function (event) {
  toggleSubmitButton();

  if (!form.checkValidity()) {
    event.preventDefault();
  } else {
    event.preventDefault();

    const address = {
      address1: document.getElementById('address-1').value,
      address2: document.getElementById('address-2').value,
      city: document.getElementById('city').value,
      country: sessionStorage.getItem('tradeInCountry') === "Canada" ? "CA" : "US",
      email: document.getElementById('email-address').value,
      emailConsent: !!document.getElementById('checkbox-email').checked,
      firstName: document.getElementById('first-name').value,
      lastName: document.getElementById('last-name').value,
      // TODO: Add per-partner handling for these 2 fields (not needed for Goose)
      needsMitiKit: false,
      phone: '',
      postalCode: document.getElementById('zip-code').value,
      state: document.getElementById('state-province').value,
    };
    validateAddress(address);
  }
});

function toggleErrorMessage(input, show = false) {
  const errorMessage = input.parentNode.lastElementChild;
  if (input.validity?.valid) {
    errorMessage.classList.add('hidden');
  } else if (show) {
    errorMessage.classList.remove('hidden');
  }
  if (input.value) {
    input.classList.add('filled');
  } else if (show) {
    input.classList.remove('filled');
  }

  // Validate PO box if allowpobox is false
  if (form.getAttribute('allowpobox') === 'false') {
    if (input.id === 'address-1') {
      validatePoBox(input, poBoxErrorMessage);
    }
    if (input.id === 'address-2') {
      validatePoBox(input, poBoxErrorMessage2);
    }
  }

  // Validate Military address if allowmilitary is false
  if (form.getAttribute('allowmilitary') === 'false') {
    if (input.id === 'city') {
      validateMilitaryCity(input, militaryErrorMessage);
    }
  }
}

function toggleSubmitButton() {
  submitBtn.disabled = !form.checkValidity();
}

renderShippingCart();
